import React from 'react';

export interface SelectProps
  extends React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  label: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  function _Select(
    { label, onChange, className = '', children, ...props },
    ref
  ) {
    return (
      <label className="block">
        <span className="text-gray-500 text-[14px] font-bold mb-2 ml-2 ">
          {label}
        </span>
        <select
          ref={ref}
          onChange={onChange}
          className={`block w-full rounded-[5px] shadow-sm focus:border-dark-cyan focus:ring focus:ring-dark-blue focus:ring-opacity-20 bg-[#F2F2F2] border-[#BDBDBD] mb-4 mt-1 ${className}`}
          {...props}
        >
          {children}
        </select>
      </label>
    );
  }
);
